import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsxs as t, jsx as e } from "react/jsx-runtime";
import i from "styled-components";
import { withVDSManager as r } from "@vds-core/utilities";
import { PureComponent as o, Children as a, Fragment as n, cloneElement as l } from "react";
import s from "./ListGroupItem.js";
import c from "./ListGroupItemTitle.js";
import d from "./ListGroupItemSubtitle.js";
import p from "./ListGroupItemImage.js";
var m = i.div.withConfig({
  displayName: "StyledUnorderedList",
  componentId: "VDS__sc-1mkm0qr-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n  width: 100%;\n"])));
var u = /*#__PURE__*/function (_o) {
  _inherits(u, _o);
  function u() {
    var _this;
    _classCallCheck(this, u);
    var i;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), i = _assertThisInitialized(_assertThisInitialized(_this)), _this._renderChildren = function () {
      var _i$props = i.props,
        t = _i$props.children,
        e = _i$props.viewport,
        r = _i$props.surface,
        o = _i$props.topLine,
        s = _i$props.bottomLine,
        c = a.toArray(t).length;
      return a.map(t, function (t, i) {
        var a = t && t.type === n ? t.props.children : t;
        a = a instanceof Array ? a[0] : a;
        return "ListGroupItem" === (a.type.componentType ? a.type.componentType : "") ? l(a, Object.assign(Object.assign({}, a.props), {
          viewport: e,
          surface: r,
          topLine: o && 0 === i,
          bottomLine: s || i !== c - 1
        })) : t;
      });
    }, _this._renderItemData = function () {
      var _i$props2 = i.props,
        r = _i$props2.data,
        o = _i$props2.topLine,
        a = _i$props2.bottomLine,
        n = _i$props2.viewport,
        l = _i$props2.surface;
      return r.length && r.map(function (i, m) {
        if (!i || !Object.keys(i).length) return null;
        var u = i["data-analyticstrack"],
          h = i["data-track"],
          b = i["data-track-ignore"],
          g = i["data-clickstream"];
        return t(s, {
          disableContainerHitArea: i.disableContainerHitArea,
          surface: l,
          topLine: o && 0 === m,
          bottomLine: a || m !== r.length - 1,
          viewport: n,
          custom: !!i.children,
          actionElement: i.actionElement,
          subtitleRight: i.subtitleRight,
          descriptiveIcon: i.descriptiveIcon,
          icon: i.icon,
          toggle: i.toggle,
          checkbox: i.checkbox,
          textLink: i.textLink,
          disabled: i.disabled,
          ariaLabel: i.ariaLabel,
          ariaRole: i.ariaRole,
          onClick: i.onClick,
          id: i.id,
          textHierarchy: i.textHierarchy,
          "data-analyticstrack": u,
          "data-track": h,
          "data-track-ignore": b,
          "data-clickstream": g,
          children: [!i.children && i.image && i.image.src && e(p, {
            src: i.image.src,
            alt: i.image.alt,
            size: i.image.size
          }), !i.children && i.title && i.title.text && e(c, {
            bold: i.title && i.title.bold,
            tooltip: i.title.tooltip && (i.title.tooltip.title || i.title.tooltip.children) ? i.title.tooltip : void 0,
            children: i.title.text
          }), !i.children && i.subtitle && i.subtitle.text && e(d, {
            tooltip: i.subtitle.tooltip && (i.subtitle.tooltip.title || i.subtitle.tooltip.children) ? i.subtitle.tooltip : void 0,
            children: i.subtitle.text
          }), !!i.children && i.children]
        }, "ListGroupItem-".concat(m + 1));
      });
    };
    return _this;
  }
  _createClass(u, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        e = _this$props.data,
        i = _this$props.ariaLabel,
        r = _this$props.id;
      return t(m, {
        "aria-label": i,
        id: r,
        children: [!e && this._renderChildren(), e && this._renderItemData()]
      });
    }
  }]);
  return u;
}(o);
u.defaultProps = {
  surface: "light",
  topLine: !1,
  bottomLine: !0
};
var h = r(u);
export { h as default };